module.exports = __webpack_public_path__ + "static/media/proj3_img1.c943fd43.jpg";